module.exports = __webpack_public_path__ + "img/device_logo.2346e4fd.png";